import logo from '../assets/logo.png'
import gearImg from '../assets/gearimg.png'
import bellImg from '../assets/bellimg.png'
import profileImg from '../assets/profileimg.png'
import filterImg from '../assets/filter.png'
import clockImg from './clockimg.png'
import CameraImg from './cameraImg.png'
import logowhite from './logowhite.png'


export const  assets = {
    logo ,
    gearImg ,
    bellImg ,
    profileImg ,
    filterImg ,
    clockImg ,
    CameraImg ,
    logowhite
}